import { render, staticRenderFns } from "./action-bar.vue?vue&type=template&id=80c5cf8a"
import script from "./action-bar.vue?vue&type=script&lang=js"
export * from "./action-bar.vue?vue&type=script&lang=js"
import style0 from "./action-bar.vue?vue&type=style&index=0&id=80c5cf8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports